module.exports = __webpack_public_path__ + "static/media/newLogo.fa757d0e.png";